"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { useState, useTransition } from "react";
import SearchContainer from "@/components/search/container";
import { SearchInput } from "@/components/search/input";

export default function SearchBox({ defaultValue }: Readonly<{ defaultValue: string }>) {
  const router = useRouter();
  const params = useSearchParams();
  const [value, setValue] = useState(defaultValue);
  const [prevDefaultValue, setPrevDefaultValue] = useState(defaultValue);
  const [isPending, startTransition] = useTransition();

  if (defaultValue !== prevDefaultValue) {
    setPrevDefaultValue(defaultValue);
    setValue(defaultValue);
  }

  const removeSearchParam = () => {
    const query = new URLSearchParams(params.toString());
    query.delete("s");
    router.replace(`?${query.toString()}`);
  };

  const handleChange = (newVal: string) => {
    setValue(newVal);
    if (params.has("s")) {
      removeSearchParam();
    }
  };

  const handleSearch = () => {
    const query = new URLSearchParams(params.toString());

    if (value) query.set("s", value);
    else query.delete("s");

    startTransition(() => {
      router.push(`?${query.toString()}`);
    });
  };

  return (
    <SearchContainer
      isSearchEnabled={!!value}
      onSearch={handleSearch}
      searchLabel="جستجو"
      isLoading={isPending}
      searchBox=""

    >
      <SearchInput
        placeholder="با نام مشاور جستجو کنید ..."
        value={value}
        onChange={handleChange}
      />
    </SearchContainer>
  );
}